'use client'

import { useLocalVideo } from 'amazon-chime-sdk-component-library-react'
import { VideoCameraIcon, VideoCameraSlashIcon } from '@heroicons/react/24/outline'
import { useTranslations } from '@/lib/next-shim'

export function LocalVideoControl() {
  const { isVideoEnabled, toggleVideo } = useLocalVideo()
  const t = useTranslations('meetingControls.camera')
  const tooltip = isVideoEnabled ? t('turnOff') : t('turnOn')
  return (
    <div className="ds-tooltip" data-tip={tooltip}>
      <button
        type="button"
        className="flex rounded-full bg-white/10 p-2 text-white shadow-sm hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        onClick={toggleVideo}
        aria-label={tooltip}
      >
        {isVideoEnabled ? <VideoCameraIcon className="h-5 w-5" /> : <VideoCameraSlashIcon className="h-5 w-5" />}
      </button>
    </div>
  )
}
